import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tab } from 'semantic-ui-react';
import SystemSetting from '../../components/SystemSetting';
import { isRoot } from '../../helpers';
import OtherSetting from '../../components/OtherSetting';
import PersonalSetting from '../../components/PersonalSetting';
import OperationSetting from '../../components/OperationSetting';
import SecuritySetting from '../../components/SecuritySetting';
import BillingSettingV8 from '../../components/BillingSettingV8';
import InternalBillingSettingV817 from '../../components/InternalBillingSettingV817';
import RedemptionSettingV108 from '../../components/RedemptionSettingV108';
import ComputeSettingsV110, {
  computeTabTextV110,
} from '../../components/ComputeSettingsV110';
import RootBackupV1021, {
  rootBackupWordsV1021,
} from '../../components/RootBackupV1021';
import './settingsV108.css';

const Setting = () => {
  const { t, i18n } = useTranslation();

  let panes = [
    {
      menuItem: t('setting.tabs.personal'),
      render: () => (
        <Tab.Pane attached={false} className='personal-settings-pane-v108'>
          <PersonalSetting />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t('setting.tabs.security') || '安全性',
      render: () => (
        <Tab.Pane attached={false}>
          <SecuritySetting />
        </Tab.Pane>
      ),
    },
  ];

  panes.push({
    menuItem: t('account_credit.tab'),
    render: () => (
      <Tab.Pane attached={false} className='personal-settings-pane-v108'>
        <RedemptionSettingV108 />
      </Tab.Pane>
    ),
  });

  if (isRoot()) {
    panes.push({
      menuItem: rootBackupWordsV1021(i18n?.language).title,
      render: () => (
        <Tab.Pane attached={false}>
          <RootBackupV1021 />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.billing'),
      render: () => (
        <Tab.Pane attached={false}>
          <BillingSettingV8 />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.internal_billing'),
      render: () => (
        <Tab.Pane attached={false}>
          <InternalBillingSettingV817 />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.operation'),
      render: () => (
        <Tab.Pane attached={false}>
          <OperationSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.system'),
      render: () => (
        <Tab.Pane attached={false}>
          <SystemSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: t('setting.tabs.other'),
      render: () => (
        <Tab.Pane attached={false}>
          <OtherSetting />
        </Tab.Pane>
      ),
    });
    panes.push({
      menuItem: computeTabTextV110(i18n?.language),
      render: () => (
        <Tab.Pane attached={false} className='personal-settings-pane-v108'>
          <ComputeSettingsV110 />
        </Tab.Pane>
      ),
    });
  }

  return (
    <div className='dashboard-container management-container-v4 settings-page-v72'>
      <h1 className='settings-title-v108'>{t('header.setting')}</h1>
      <Tab
        menu={{
          secondary: true,
          pointing: true,
          className: 'settings-tab',
        }}
        panes={panes}
      />
    </div>
  );
};

export default Setting;
